export enum VisitCreationFlow {
  STANDARD = 'standard',
  CONTACT_WAIVER = 'contact-waiver',
}
